import { Injectable } from '@angular/core';
import { ApiError } from './api-error';

@Injectable({
  providedIn: 'root'
})
export class ApiErrorService {

  public error!: ApiError;

  constructor() { }
}
